import React from 'react';
import { FadeIn } from './FadeIn';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  const checkoutUrl = 'https://pay.hotmart.com/H104825392W?off=a2wkwelk&checkoutMode=10';
  return <section className="py-20 md:py-32 px-4 bg-green-deep text-white text-center" data-id="element-49">
      <div className="max-w-3xl mx-auto" data-id="element-50">
        <FadeIn data-id="element-51">
          <h2 className="font-heading font-bold text-3xl md:text-5xl mb-8 leading-tight" data-id="element-52">
            El próximo invierno va a llegar.
          </h2>
        </FadeIn>

        <div className="space-y-6 text-green-mint font-body text-lg md:text-xl mb-12" data-id="element-53">
          <FadeIn delay={0.1} data-id="element-54">
            <p data-id="element-55">Los virus del jardín van a seguir circulando.</p>
            <p data-id="element-56">La pregunta no es si tu hijo va a estar expuesto.</p>
            <p className="text-white font-bold text-xl md:text-2xl mt-4" data-id="element-57">
              La pregunta es si su cuerpo va a estar listo.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-58">
            <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mt-8" data-id="element-59">
              Podés llegar a junio igual que el año pasado — con el botiquín
              lleno de antibióticos y el corazón lleno de culpa.
            </p>
            <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto" data-id="element-60">
              O podés llegar con un hijo que tiene un sistema inmune construido
              desde adentro, una microbiota diversa y una mamá que sabe
              exactamente qué hacer en las primeras dos horas cuando aparece el
              primer síntoma.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-61">
            <p className="text-orange-warm font-bold text-2xl md:text-3xl mt-8" data-id="element-62">
              Esa mamá sos vos. Ya tenés lo que se necesita.
            </p>
            <p className="text-white" data-id="element-63">Solo falta el sistema.</p>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} data-id="element-64">
          <a href={checkoutUrl} className="block w-full md:w-auto md:inline-block bg-orange-warm text-white font-bold text-lg md:text-xl py-5 px-10 rounded-xl shadow-lg hover:scale-[1.02] transition-transform duration-300 animate-pulse-slow mb-8" data-id="element-65">
            🛡️ SÍ, QUIERO INMUNIDAD TOTAL
            <br data-id="element-66" />
            <span className="text-sm md:text-base font-normal opacity-90" data-id="element-67">
              ACCEDER AHORA POR $37
            </span>
          </a>

          <div className="bg-white/10 border border-white/20 rounded-xl p-6 max-w-md mx-auto backdrop-blur-sm" data-id="element-68">
            <p className="text-orange-warm font-bold uppercase tracking-wider text-sm mb-3 flex items-center justify-center gap-2" data-id="element-69">
              ⚠️ Esta oferta es por tiempo limitado
            </p>
            <CountdownTimer className="mb-3" data-id="element-70" />
            <p className="text-green-mint text-sm" data-id="element-71">
              El precio especial de $37 está disponible hoy.
              <br data-id="element-72" />
              Precio regular: $99
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}